import React, { useState } from 'react';
import { Stack } from '@fluentui/react';
import { HeaderMargin } from '../../utility/tasks/styles';
import MetaDataPanel from '../metaDataPanel/metaDataPanel';
import ActionUploadAttachment from './upload/ActionUploadAttachment';
import { THEME_ID } from '../../shared/styles';
import { SPLIT_SIZES } from '../../shared/Constants';

const PMForm = ({ docData, isLoading, isSubmitting, currentOfficeTheme, handleBtnPress }) => {
	const [isAttchVisible, setIsAttchVisible] = useState(true);

	const handleAttContainerSize = size => {
		if (size > SPLIT_SIZES.MIN) {
			setIsAttchVisible(true);
		} else {
			setIsAttchVisible(prev => !prev);
		}
	};
	const formContainerStyles = {
		display: 'flex-block',
		flex: 1,
		paddingBottom: '1rem',
		overflowY: 'auto',
	};

	return (
		<Stack
			tokens={HeaderMargin}
			style={{
				position: 'relative',
				height: 'calc(100dvh - 50px)',
				overflowY: 'hidden',
			}}
		>
			<Stack style={formContainerStyles}>
				<MetaDataPanel data={docData} />
			</Stack>

			<Stack>
				<ActionUploadAttachment
					btnLabel={isSubmitting ? 'SAVING FILES' : 'SAVE SELECTED FILES'}
					isDisabled={isLoading || isSubmitting}
					isAttachmentVisible={isAttchVisible}
					onBtnPress={handleBtnPress}
					handleContainerSizeChange={handleAttContainerSize}
					parentContainerStyle={{
						borderTop: `1px solid 
                ${
					currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
						? currentOfficeTheme.bodyForegroundColor
						: 'rgb(128,128,128, 0.4)'
				}`,
					}}
				/>
			</Stack>
		</Stack>
	);
};

export default PMForm;
